import { ApiService, SonicPractice } from "pwapi";

import SelectSearchInput from "../edit/SelectSearchInput";

const mapSonicPracticeToOptions = (clinics: SonicPractice[]) => [
  { value: undefined, label: "All Sonic Practices", object: undefined },
  ...clinics.map((sonicPractice) => ({
    value: sonicPractice.name,
    label: `${sonicPractice.name}${
      sonicPractice.acronym ? ` (${sonicPractice.acronym})` : ""
    }`,
    object: sonicPractice,
  })),
];

const SonicPracticeFilter = ({
  onChange,
  value,
  label = "Sonic Practice",
}: {
  onChange: Function;
  value?: string;
  label?: string;
}) => {
  return (
    <SelectSearchInput
      label={label}
      field="Sonic Practice"
      filter="name"
      onChange={onChange}
      mapToOptions={mapSonicPracticeToOptions}
      apiService={ApiService.listSonicPractices}
    >
      <>{value || "All Sonic Practices"}</>
    </SelectSearchInput>
  );
};

export default SonicPracticeFilter;
